import React from "react";
import { useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";

import { Card } from "react-bootstrap";

import "~/assets/css/icons.css";

import BatchTable from "./components/BatchTable";
import CustomDropdown from "../CustomDropdown";
import Spinner from "~/components/Spinner";
import Messages from "~/components/Messages";

const DataCaptureWidget = ({ t, apagarWidget, widget }) => {
  const { isLoadingBatchs, isLoadingUpdateBatch, isLoadingDeleteBatch } =
    useSelector((state) => state.dataCaptureReducer);

  return (
    <>
      <div className="main-card-v2">
        <Card bsPrefix="card-flat">
          <Card.Header className="justify-content-between">
            <h6>
              <i className="icon-tarefas2 mr-2" />
              {t("DataCaptureWidget.title")}
            </h6>
            <CustomDropdown apagarWidget={apagarWidget} />
          </Card.Header>
          <Card.Body>
            <BatchTable widget={widget} />
          </Card.Body>
        </Card>
      </div>

      <Spinner
        spinning={
          isLoadingBatchs || isLoadingDeleteBatch || isLoadingUpdateBatch
        }
        wrapper
      />
      <Messages />
    </>
  );
};
export default withNamespaces()(DataCaptureWidget);
